import { CheckCircle, AlertCircle, Info, X } from "lucide-react";
import { useEffect } from "react";

interface ToastProps {
  message: string;
  type: "success" | "error" | "info" | "pending";
  onClose: () => void;
  txHash?: string;
  chainId?: number;
  duration?: number;
}

export default function Toast({ message, type, onClose, txHash, chainId, duration = 5000 }: ToastProps) {
  useEffect(() => {
    if (type === "pending") return;
    const t = setTimeout(onClose, duration);
    return () => clearTimeout(t);
  }, [duration, onClose, type]);

  const styles = {
    success: "bg-green-500",
    error:   "bg-red-500",
    info:    "bg-blue-600",
    pending: "bg-yellow-500",
  };
  const Icon = type === "success" ? CheckCircle : type === "error" ? AlertCircle : Info;
  const explorer = chainId === 80002 ? "https://amoy.polygonscan.com" : "https://polygonscan.com";

  return (
    <div className="fixed top-4 right-4 z-50 animate-slideInRight">
      <div className={`${styles[type]} text-white rounded-lg shadow-2xl p-4 flex items-center gap-3 min-w-[300px] max-w-md`}>
        <Icon className="w-6 h-6 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="font-medium">{message}</p>
          {txHash && (
            <a
              href={`${explorer}/tx/${txHash}`}
              target="_blank"
              rel="noreferrer"
              className="text-xs underline opacity-80"
            >
              View on Polygonscan ↗
            </a>
          )}
        </div>
        <button onClick={onClose} className="p-1 hover:bg-white/20 rounded transition-colors">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
